export default "__VITE_ASSET__fobcZwLT__"